import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpModule,Http } from '@angular/http';

import { orderbagrouts } from './orderbag.routes';
import {InfoBoxContentComponent} from "../component/map/info-box-content.component";

import {CompanyService} from "../services/company-service/company-service";
import {CategoryService} from "../services/category/category.service";
import {ShareModule} from "../share/share.module";
import {TranslateModule,TranslateLoader,TranslateStaticLoader} from "ng2-translate";
import {PageSliderModule}    from 'ng2-page-slider';
import { SwiperModule } from 'angular2-useful-swiper';
import {OrderBagService} from "../services/orderbag/orderbag.service";
import {OrderBagComponent} from "./orderbag.component";
import {OrderBagListComponent} from "./orderbag-list.component";
import { LoadingModule } from 'ngx-loading';


@NgModule({

  imports: [
    CommonModule,
    FormsModule,
    ShareModule,
    SwiperModule,
    LoadingModule,
    RouterModule.forChild(orderbagrouts),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory:TranslateStaticLoaderFun,
      deps: [Http]
    }),
    //PageSliderModule
  ],
  providers: [CompanyService, CategoryService, OrderBagService],
  declarations: [
    OrderBagComponent,
    OrderBagListComponent
  ]
})
export class OrderBagModule {
  public static routes = orderbagrouts;
}
export function TranslateStaticLoaderFun(http: Http) {
  return   new TranslateStaticLoader(http, '/assets/i18n-14011218n', '.json')
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/+orderbag/orderbag.module.ts